if (!customElements.get('product-availability')) {

  class productAvailability extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      window.addEventListener("variant:changed", (e) => {
        if (e.detail.variant.available) {
          this.querySelector('[data-available="true"]').classList.remove('hidden');
          this.querySelector('[data-available="false"]').classList.add('hidden');
        } else {
          this.querySelector('[data-available="true"]').classList.add('hidden');
          this.querySelector('[data-available="false"]').classList.remove('hidden');
        }
      });
    }
  }
  
  customElements.define('product-availability', productAvailability);
}